export default "__VITE_ASSET__2c636310__"